<template>
  <div class="login-modal" :class="{mobile: isMobile}">
    <img src="../../../static/images/logo/iPastBook-logo.svg" height="24" alt="logo">
    <p class="login-desc">
      <span>社交賬號登入</span>
    </p>
    <div class="btn-groups">
      <a class="login-btn fb-login-btn" :href="FBAuthLink">
        <img src="../../../static/images/logo/facebook-logo.png" class="fb-login-icon"/>
      </a>
    </div>
    <div class="close-btn" @click="$emit('close')"></div>
  </div>
</template>

<script>
export default {
  name: '',
  data () {
    return {}
  },
  computed: {
    FBAuthLink () {
      const link = '/social/facebook_login'
      const { needRedirect } = this.$route.meta
      return needRedirect ? `${link}?state=redirect_${encodeURIComponent(window.location.href)}` : link
    }
  },
  created () {
  }
}
</script>

<style lang="scss">
@import '../../styles/layout/LoginModal';
</style>
